import { Preview } from "../../../../types/IAction";
import * as actions from "../../../actions/personaReferencia";
import { PutHomologarTitularMayor } from "../../../reducers/personaReferencia";

export interface HomologarTitularMayorDispatcher {
  putHomologarTitularMayor: (
    idMembresiaSocio: number,
    idTitular: number
  ) => Promise<Preview<PutHomologarTitularMayor>>;
  clearPersonaReferencia: () => void;
}

export const homologarTitularMayorDispatcher: (
  dispatch: (...args) => Promise<Preview<any>>
) => HomologarTitularMayorDispatcher = dispatch => ({
  putHomologarTitularMayor: (idMembresiaSocio: number, idTitular: number) =>
    dispatch(actions.putHomologarTitularMayor(idMembresiaSocio, idTitular)),
  clearPersonaReferencia: () => dispatch(actions.clearPersonaReferencia())
});
